/**
 * @file
 * Page Footer component behaviors.
 *
 * @param {object} Drupal - The Drupal object.
 */

(function (Drupal) {
  'use strict';

  /**
   * Behavior for Page Footer component.
   *
   * @type {object}
   */
  Drupal.behaviors.pageFooter = {
    attach: function (context) {
      once('page-footer', '.page-footer', context).forEach((component) => {
        component.addEventListener('click', function onAccordionClick(event) {
          const btn = event.target.closest('.accordion-toggle[aria-controls]');
          if (!btn) {
            return true;
          }

          const panel = document.getElementById(
            btn.getAttribute('aria-controls')
          );
          if (!panel) {
            return false;
          }

          const expanded = btn.getAttribute('aria-expanded') === 'true';

          // Collapse currently active item if target will be expanded
          if (!expanded) {
            const activeToggle = component.querySelector(
              '.accordion-toggle[aria-expanded="true"]'
            );
            if (activeToggle && activeToggle !== btn) {
              activeToggle.setAttribute('aria-expanded', 'false');
              const activePanel = document.getElementById(
                activeToggle.getAttribute('aria-controls')
              );

              if (activePanel) {
                activePanel.hidden = activePanel !== panel ? true : null;
              }
            }
          }

          btn.setAttribute('aria-expanded', String(!expanded));
          panel.hidden = expanded ? true : null;
        });

        const breakpointValue = (window.getComputedStyle(
          document.documentElement
        )).getPropertyValue('--breakpoint-tablet');

        if (!breakpointValue) {
          return;
        }

        const breakpoint = window.matchMedia(
          `(min-width: ${breakpointValue})`
        );

        const toggles = document.querySelectorAll(
          '.accordion-toggle[aria-controls]'
        );

        const onWindowResize = () => {
          toggles.forEach(toggle => {
            toggle.setAttribute('aria-expanded', String(breakpoint.matches));
            const panel = document.getElementById(
              toggle.getAttribute('aria-controls')
            );

            if (panel) {
              panel.hidden = breakpoint.matches ? null : true;
            }
          });
        };
        window.addEventListener('resize', onWindowResize);
        screen.orientation.addEventListener('change', onWindowResize);
        onWindowResize();
      });
    }
  };
})(Drupal);
